export enum ChartTitlePosition {
  Top = 0,
  Bottom = 1,
}
